import { useEffect, useRef, useState } from 'react'

export const UseChatHelpTimer = () => {
  const timer = useRef(null)
  const [shouldRenderChat, setShouldRenderChat] = useState(false)
  const [time, setTime] = useState(0)

  const initChatHelper = () => {
    clearTimer() // limpa o timer anterior antes de iniciar outro
    timer.current = setTimeout(() => {
      //window.openCXGenieChatWidget()
      setShouldRenderChat(false)
    }, time);
  }

  useEffect(() => {
    shouldRenderChat && initChatHelper()
  }, [shouldRenderChat])

  const restartTimer = () => {
    if(shouldRenderChat){
      clearTimer()
      initChatHelper()
    }
  }

  const clearTimer = () => {
    if (timer.current) {
      clearTimeout(timer.current)
      timer.current = null
    }
  }

  return { 
    restartTimer,
    timer, 
    clearTimer,
    setShouldRenderChat,
    shouldRenderChat,
    initChatHelper,
    setTime
  }
}